import React, { useEffect, useState } from "react";

export default function EnquireManager() {
  const [search, setSearch] = useState("");
  const [enquiries, setEnquiries] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 50;
  const totalPages = Math.ceil(enquiries.length / pageSize);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/enquiry`)
      .then(res => res.json())
      .then(data => setEnquiries(data))
      .catch(() => setEnquiries([]))
      .finally(() => setLoading(false));
  }, []);

  const handleToggleAttended = async (id, attended) => {
    setEnquiries(enquiries => enquiries.map(e => e._id === id ? { ...e, attended: !attended } : e));
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/enquiry/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attended: !attended })
    });
  };

  return (
    <div>
      <h4 className="mb-3">Enquiries</h4>
      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <div>
          <div className="mb-2">
            <input type="text" className="form-control" placeholder="Search enquiries..." value={search} onChange={e => setSearch(e.target.value)} />
          </div>
          <div className="table-responsive">
            <table className="table table-bordered align-middle">
              <thead className="table-light">
                <tr>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Symptoms</th>
                  <th>Comments</th>
                  <th>Attended</th>
                </tr>
              </thead>
              <tbody>
                {enquiries.length === 0 ? (
                  <tr><td colSpan={7} className="text-center">No enquiries found.</td></tr>
                ) : (
                  enquiries.filter(e => {
                    if (!search) return true;
                    const val = search.toLowerCase();
                    return (
                      e.name?.toLowerCase().includes(val) ||
                      e.email?.toLowerCase().includes(val) ||
                      e.phone?.toLowerCase().includes(val) ||
                      e.symptoms?.toLowerCase().includes(val) ||
                      e.comments?.toLowerCase().includes(val)
                    );
                  }).slice((page-1)*pageSize, page*pageSize).map(e => (
                    <tr key={e._id || e.name + e.phone}>
                      <td>{e.name}</td>
                      <td>{e.age}</td>
                      <td>{e.phone}</td>
                      <td>{e.email}</td>
                      <td>{e.symptoms}</td>
                      <td>{e.comments}</td>
                      <td className="text-center">
                        {e.attended ? (
                          <span className="text-success fw-bold">Done</span>
                        ) : (
                          <button
                            className="btn btn-link p-0 text-secondary"
                            title="Mark as attended"
                            onClick={() => handleToggleAttended(e._id, e.attended)}
                            style={{ fontSize: "1.3em" }}
                          >
                            &#10003;
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
                <button className="btn btn-outline-secondary btn-sm" disabled={page===1} onClick={()=>setPage(page-1)}>Prev</button>
                <span>Page {page} of {totalPages}</span>
                <button className="btn btn-outline-secondary btn-sm" disabled={page===totalPages} onClick={()=>setPage(page+1)}>Next</button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
 
